<template>
  <div class="px-20">
    <vs-popup
      class="custom-popup editPromo-popup"
      classContent="popup-example"
      :title="`${formData['actionName']} Internal Promo`"
      :active.sync="editPromoRequestPopup"
    >
      <div slot="header">Internal Promo</div>
      
      <div class="static-box-header">
        <div class="header">INTERNAL PROMOS</div>
        <div class="form-actions">
          <vx-tooltip text="Copy any end date manually and click here to paste it to all entries" position="top">
            <vs-button
              class="iconOnly"
              color="dark"
              type="flat"
              icon-pack="feather"
              icon="icon-copy"
              @click="copyEndDate"
            ></vs-button>
          </vx-tooltip>
        </div>
      </div>
      <div class="horizontal-scrollable-area">
        <div class="internalPromo-editForm table-form pr-4 pl-4">
          <ul class="table-head">
            <li class="theading">Client Name</li>
            <li class="theading">TLD</li>
            <li class="theading">Type</li>
            <li class="theading">Period (Yrs)</li>
            <li class="theading">Start Date</li>
            <li class="theading">End Date</li>
            <li class="theading">Retail Price</li>
            <li class="theading">Effective 1Yr Price</li>
            <li class="theading">Effective Multi-Yr Price</li>
            <li class="theading">Promo Tag</li>
            <li class="theading">Custom Tag</li>
            <li class="theading">Geo</li>
            <li class="theading">Rebate Status</li>
            <li class="theading">Comments</li>
          </ul>
          <div v-for="(promo, counter) in promos" v-bind:key="counter">
            <ul class="promo-repeater table-body">
              <li>
                <div class="table-form-component flex">
                  <v-select
                    :name="`reseller-${counter}`"
                    class="w-4/5"
                    v-model="promo.reseller_id"
                    :options="formResellers"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    :clearable="false"
                    :disabled="
                      flags['disableInput'] || flags['enableOnlyRebateStatus']
                    "
                  ></v-select>
                </div>
              </li>
              <li>
                <div class="table-form-component flex">
                  <v-select
                    :name="`tld-${counter}`"
                    class="w-4/5"
                    v-model="promo.tld_id"
                    :options="formTlds"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    :multiple="false"
                    :closeOnSelect="true"
                    :clearable="false"
                    :disabled="
                      flags['disableInput'] || flags['enableOnlyRebateStatus']
                    "
                  >
                  </v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`tld-${counter}`)"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <v-select
                    :name="`type-${counter}`"
                    class="w-full"
                    v-model="promo.type"
                    @input="handlePeriod($event)"
                    :options="formInit['types']"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    :clearable="false"
                    :disabled="
                      flags['disableInput'] || flags['enableOnlyRebateStatus']
                    "
                  ></v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`type-${counter}`)"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <v-select
                    :name="`period-${counter}`"
                    class="w-full"
                    v-model="promo.period"
                    :options="formInit['periods']"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    @input="handlePeriod($event)"
                    :multiple="true"
                    :closeOnSelect="false"
                    :clearable="false"
                    :selectable="
                      promo.selectableOption !== '' &&
                      promo.selectableOption === 'All'
                        ? (option) => option === '1'
                        : promo.selectableOption === ''
                        ? (option) => true
                        : (option) => option !== '1'
                    "
                    :disabled="
                      flags['disableInput'] || flags['enableOnlyRebateStatus']
                    "
                  ></v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`period-${counter}`)"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <flat-pickr
                    :name="`start date-${counter}`"
                    v-model="promo.start_date"
                    placeholder="YYYY-MM-DD"
                    class="w-full"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    :config="promo.configFromdateTimePicker"
                    @on-change="onFromChange($event, counter)"
                    :disabled="!flags['duplicatebtn']" />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`start date-${counter}`)">
                    Required field
                  </span>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <flat-pickr
                    :name="`end date-${counter}`"
                    v-model="promo.end_date"
                    placeholder="YYYY-MM-DD"
                    class="w-full"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    :config="promo.configTodateTimePicker"
                    @on-change="onToChange($event, counter)"
                    :disabled="flags['enableOnlyRebateStatus']"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`end date-${counter}`)"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <div class="flex">
                    <v-select
                      name="currencyType"
                      class="w-3/5 retail-currency"
                      v-model="promo.retail_currency"
                      :options="formCurrencies"
                      :clearable="false"
                      :disabled="flags['enableOnlyRebateStatus']"
                    ></v-select>
                    <vs-input
                      :name="`retail price-${counter}`"
                      class="w-2/5"
                      v-validate="
                        promo.type.includes('premium') ||
                        flags['enableOnlyRebateStatus']
                          ? ''
                          : 'required'
                      "
                      data-vv-validate-on="blur"
                      v-model="promo.retail_price"
                      :disabled="
                        promo.type.includes('premium') ||
                        flags['enableOnlyRebateStatus']
                      "
                    />
                  </div>
                  <span
                    class="text-danger text-sm"
                    v-if="errors.has(`retail price-${counter}`)"
                  >
                    Required field
                  </span>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <div
                    v-if="promo.type.includes('premium')"
                    class="inputPrefix"
                  >
                    <vs-input
                      :name="`year price per-${counter}`"
                      class="w-full"
                      v-validate="promo.disabledYearPrice ? '' : 'required'"
                      data-vv-validate-on="blur"
                      v-model="promo.year_price_per"
                      icon-pack="feather"
                      icon="icon-percent"
                      icon-no-border
                      :key="`per-input-${counter}`"
                      :disabled="
                        promo.disabledYearPrice ||
                        flags['enableOnlyRebateStatus']
                      "
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has(`year price per-${counter}`)"
                    >
                      Required field
                    </span>
                  </div>
                  <div v-else class="inputPrefix">
                    <vs-input
                      :name="`year price-${counter}`"
                      class="w-full"
                      v-validate="promo.disabledYearPrice ? '' : 'required'"
                      data-vv-validate-on="blur"
                      v-model="promo.year_price"
                      :key="`amt-input-${counter}`"
                      :disabled="
                        promo.disabledYearPrice ||
                        flags['enableOnlyRebateStatus']
                      "
                    />
                    <span class="currency-sign">{{ promo.currencySign }}</span>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has(`year price-${counter}`)"
                    >
                      Required field
                    </span>
                  </div>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <div
                    v-if="promo.type.includes('premium')"
                    class="inputPrefix"
                  >
                    <vs-input
                      :name="`multi year price per-${counter}`"
                      class="w-full"
                      v-validate="promo.disabledMultiYearPrice || promo.type.includes('renew') ? '' : 'required'"
                      data-vv-validate-on="blur"
                      v-model="promo.multi_year_price_per"
                      icon-pack="feather"
                      icon="icon-percent"
                      icon-no-border
                      :key="`multi-year-per-input-${counter}`"
                      :disabled="
                        flags['enableOnlyRebateStatus'] ||
                        promo.type.includes('renew') ||
                        promo.disabledMultiYearPrice"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has(`multi year price per-${counter}`)"
                    >
                      Required field
                    </span>
                  </div>
                  <div v-else class="inputPrefix">
                    <vs-input
                      :name="`multi year price-${counter}`"
                      class="w-full"
                      v-validate="promo.disabledMultiYearPrice || promo.type.includes('renew') ? '' : 'required'"
                      data-vv-validate-on="blur"
                      v-model="promo.multi_year_price"
                      :key="`multi-year-input-${counter}`"
                      :disabled="
                        flags['enableOnlyRebateStatus'] ||
                        promo.type.includes('renew') ||
                        promo.disabledMultiYearPrice"
                    />
                    <span class="currency-sign">{{ promo.currencySign }}</span>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has(`multi year price-${counter}`)"
                    >
                      Required field
                    </span>
                  </div>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <v-select
                    :name="`promo tag-${counter}`"
                    class="w-full"
                    v-validate="'required'"
                    v-model="promo.promo_tag"
                    :options="formPromoTags"
                    data-vv-validate-on="blur"
                    :clearable="false"
                    :disabled="flags['enableOnlyRebateStatus']"
                  ></v-select>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has(`promo tag-${counter}`)"
                    >Required field</span
                  >
                </div>
              </li>
              <li>
                <div class="table-form-component flex">
                  <v-select
                    :name="`custom tag-${counter}`"
                    class="sm:w-4/5"
                    v-model="promo.custom_tag"
                    :options="formCustomTags"
                    :clearable="false"
                  ></v-select>
                  <div class="sm:w-1/5 inline-flex">
                    <vs-button
                      @click="openAddTagModal(counter)"
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-plus"
                      style="padding: 0 !important"
                    ></vs-button>
                  </div>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <v-select
                    :name="`geo-${counter}`"
                    class="w-full"
                    v-model="promo.geo"
                    :options="formGeo"
                    data-vv-validate-on="blur"
                    :clearable="false"
                    :disabled="flags['enableOnlyRebateStatus']"
                  ></v-select>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <Datepicker
                    :format="customMonthFormatter"
                    :minimum-view="'month'"
                    :maximum-view="'year'"
                    :name="`promo-rebates-status-${counter}`"
                    v-model="promo.rebates_status"
                    placeholder="MM-YYYY"
                    class="w-full"
                    :disabled="!flags['enableOnlyRebateStatus']"
                  >
                  </Datepicker>
                </div>
              </li>
              <li>
                <div class="table-form-component">
                  <vs-input
                    :name="`comments-${counter}`"
                    class="w-full"
                    v-model="promo.comments"
                    data-vv-validate-on="blur"
                    :clearable="false"
                  ></vs-input>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flex justify-end pb-4 pr-4 pt-2">
        <vs-button
          v-show="!flags['disableInput'] && !flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onSubmit()"
          >Save</vs-button
        >
        <vs-button
          v-show="flags['disableInput'] && !flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onEditSubmit()"
          >Save</vs-button
        >
        <vs-button
          v-show="flags['duplicatebtn']"
          color="primary"
          type="filled"
          class="action-btn"
          @click="onDuplicateSubmit()"
          >Save</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="customTag-popup"
      title="Add Custom Tag"
      :active.sync="popupCustomTag"
    >
      <div
        id="div-with-modal-loading"
        class="div-with-agreement-modal-loading vs-con-loading__container"
      >
        <div class="vx-row flex-wrap">
          <div class="vx-col w-full mb-6 flex flex-wrap">
            <div class="w-6/12 pl-2 pr-2">
              <label class="vs-input--label inline-flex pb-2">Tag Name:</label>
              <vs-input class="w-full" v-model="formData['CustomeTagName']" />
              <span
                v-show="formData['existingTagName']"
                class="text-danger text-sm"
                >{{ formData["existingTagName"] }}</span
              >
            </div>
            <div class="w-6/12 pl-2 pr-2">
              <label class="vs-input--label inline-flex pb-2">Comments:</label>
              <vs-textarea
                class="w-full"
                v-model="formData['CustomeTagComments']"
              />
            </div>
          </div>
        </div>
        <vs-button
          id="button-with-loading"
          color="primary"
          type="filled"
          class="action-btn flex mr-auto ml-auto mb-4"
          @click="onAddCustomTag()"
          :disabled="
            formData['CustomeTagName'] == '' ||
            formData['CustomeTagComments'] == ''
          "
          >Save</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import Datepicker from "vuejs-datepicker";

export default {
  name: "EditInternalPromo",
  components: {
    "v-select": vSelect,
    flatPickr,
    vueCustomScrollbar,
    Datepicker,
  },
  data() {
    return {
      editReq: false,
      promos: [
        {
          type: [],
          tld_id: [],
          period: [],
          start_date: null,
          currencySign: "$",
          end_date: null,
          retail_price: "",
          retail_currency: {
            label: "USD  -  $",
            value: 12,
            sign: "$",
          },
          year_price: "",
          multi_year_price: "",
          year_price_per: "",
          multi_year_price_per: "",
          promo_tag: [],
          custom_tag: { label: "NA", value: null },
          geo: { label: "NA", value: null },
          comments: "",
          id: "",
          reseller_id: "",
          status: "",
          disabledYearPrice: false,
          disabledMultiYearPrice: false,
          new_local_agreement: null,
          fileLocalData: [],
          uploadedLocalFile: "",
          selectableOption: "",
          configFromdateTimePicker: {
            maxDate: null,
            wrap: true,
          },
          configTodateTimePicker: {
            minDate: null,
            wrap: true,
          },
        },
      ],
      formData: {
        actionName: "",
        reseller_id: [],
        currency_type: { label: "USD  -  $", value: 12 },
        // payment_mode: [],
        payment_mode: "",
        list_frequency: "",
        list_based: "Yes",
        agreement: { label: "New", value: null },
        general_agreements: null,
        localpromo: [],
        start_date: null,
        end_date: null,
        signedCheckbox: [],
        signedPromoCheckbox: [],
        generalName: [],
        status: "",
        fileName: "",
        fileTypeError: "",
        fileSizeError: "",
        reject_comments: "",
        CustomeTagName: "",
        CustomeTagComments: "",
        TagNameData: "",
        existingTagName: "",
      },
      formInit: {
        reseller_ids: [],
        payment_modes: ["CNIC", "Bank Transfer"],
        list_frequencies: ["Monthly", "Quarterly"],
        agreements: [],
        types: ["new", "renew", "premium new", "premium renew"],
        periods: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
        tld_ids: [],
        promo_tags: [],
        custom_tags: [],
        geos: [],
        currencies: [],
      },
      batchId: "",
      fileGeneralData: [],
      editPromoRequestPopup: false,
      popupActive: false,
      popupActivePromo: false,
      popupCustomTag: false,
      tldValForAgreement: "",
      indexForLocalAgreement: "",
      uploadAgreementText: "New Agreement",
      uploadedFile: "",
      activePrompt: false,
      rejectPromoId: "",
      popupCustomTag: false,
      tempCustomTag: "",
      configFromdateTimePicker: {
        // minDate: new Date(),
        maxDate: null,
        wrap: true,
      },
      configTodateTimePicker: {
        minDate: null,
        wrap: true,
      },
      extended: false,
      flags: {
        isApproved: false,
        isDuplicate: false,
        disableInput: false,
        duplicatebtn: false,
        enableOnlyRebateStatus: false,
      },
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
    };
  },
  mounted() {
    let self = this;
    this.$root.$on(
      "selectedGroupEditInternal",
      (nodeData, extended, editReq) => {
        if (extended) {
          this.extended = true;
        }

        if (editReq) {
          this.editReq = true;
        }

        this.formatGroupEditData(nodeData);
        this.editPromoRequestPopup = true;
        this.formData["actionName"] = "Edit";
      }
    );

    this.$root.$on("duplicatePromoInternal", (nodeData) => {
      // this.formatGroupEditData(nodeData);
      this.formData["actionName"] = "Duplicate";

      this.formatSingleDuplicateData(nodeData);
      this.editPromoRequestPopup = true;
      this.flags["duplicatebtn"] = true;
    });
  },
  beforeMount() {
    if (this.isBIUserRole) {
      this.flags["enableOnlyRebateStatus"] = true;
    }
  },
  destroyed() {
    this.$root.$off("selectedGroupEdit");
  },
  watch: {
    editPromoRequestPopup(val) {
      if (!val) {
        this.errors.clear();
        setTimeout(() => {
          this.flags["duplicatebtn"] = false;
          this.flags["disableInput"] = false;
        }, 10);
      }
    },
    // NOTE: Vuex master data getters(helpers)
    formResellers() {
      return this.$store.getters.formResellers;
    },
    formTlds() {
      return this.$store.getters.formTlds;
    },
    formPromoTags() {
        return this.$store.getters.formPromoTags;
    },
    formCustomTags() {
        return this.$store.getters.formCustomTags;
    },
    formCurrencies() {
        return this.$store.getters.formCurrencies;
    },
    formGeo() {
        return this.$store.getters.formGeo;
    }
  },
  computed: {
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },

    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    isBIUserRole() {
      // return this.$acl.check('isBIUser');
      return JSON.parse(localStorage.getItem("userDetails")).role == 'bi_user';
    },
    formAgreement: function () {
      let agreementArray = this.formInit["agreements"].map((x) => {
        return {
          label: x["filename"],
          name: x["original_filename"],
          value: x["id"],
          id: x["reseller_id"],
        };
      });

      return agreementArray;
    },

    formAgreementFilteredByReseller: function () {
      let resellerID = this.formData["reseller_id"]["value"];

      if (resellerID !== null) {
        let formAggFilter = this.formAgreement.filter(
          (x) => x["id"] == resellerID
        );
        return [
          {
            label: "New",
            value: null,
          },
          ...formAggFilter,
        ];
      }
    },
    // NOTE: Vuex master data getters(helpers)
    formResellers() {
      return this.$store.getters.formResellers;
    },
    formTlds() {
      return this.$store.getters.formTlds;
    },
    formPromoTags() {
        return this.$store.getters.formPromoTags;
    },
    formCustomTags() {
        return this.$store.getters.formCustomTags;
    },
    formCurrencies() {
        return this.$store.getters.formCurrencies;
    },
    formGeo() {
        return this.$store.getters.formGeo;
    },
    validComment() {
      return this.formData["reject_comments"].length > 0;
    },
    rejectTitle() {
      return "Reject Selected Promos?";
    },
    yesText() {
      return "Yes";
    },
    noText() {
      return "No";
    },
  },
  methods: {
    customMonthFormatter(date) {
      return this.$moment(date).format("MMMM YYYY");
    },

    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },

    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },

    formatGroupEditData(nodeData) {
      this.promos.splice(0);

      var groupData = nodeData;

      var getTempType,
        getTempTLD,
        getTempPeriod,
        getTempStartDate,
        getTempEndDate,
        getTempYearPrice,
        getTempMultiYearPrice,
        getTempYearPerPrice,
        getTempMultiYearPerPrice,
        getTempRetailPrice,
        getTempPromoTag = [],
        getTempCustomTag = [],
        getTempGeo = [],
        getTempComments,
        getTempId,
        getTempPromoId,
        getTempResellerId,
        getTempStatus,
        getRetailCurrency = [],
        getRebatesStatus = {},
        getListBased,
        getPaymentMode = [],
        getListFreq = [],
        getCurrencyId;
        
      var approvedCheck = groupData.some((x) => x.approved_by);

      if (approvedCheck) {
        this.flags["disableInput"] = true;
      } else {
        this.flags["disableInput"] = false;
      }

      getTempTLD = groupData.map((x) => {
        return {
          label: x.tld.tld_name,
          name: x.tld.tld_name,
          value: x.tld_id,
        };
      });
      getTempType = groupData.map((x) => x.type);
      getTempStatus = groupData.map((x) => x.status);
      getTempId = groupData.map((x) => x.id);
      getTempPromoId = groupData.map((x) => x.promo_id);
      getTempPeriod = groupData.map((x) => x.period);
      getTempStartDate = groupData.map((x) => x.start_date);
      getTempEndDate = groupData.map((x) => x.end_date);
      getTempResellerId = groupData.map((x) => {
        return {
          label: x.new_reseller.name,
          name: x.new_reseller.name,
          value: x.new_reseller_id,
        };
      });

      getTempYearPrice = groupData.map((x) => x.effective_first);
      getTempMultiYearPrice = groupData.map((x) => x.effective_multi);
      getTempYearPerPrice = groupData.map((x) => x.effective_first_per);
      getTempMultiYearPerPrice = groupData.map((x) => x.effective_multi_per);
      getTempRetailPrice = groupData.map((x) => x.retail_price);
      getListBased = groupData.map((x) => x.list_based);
      getPaymentMode = groupData.map((x) => x.payment_mode ? x.payment_mode.toLowerCase() : null);
      getListFreq = groupData.map((x) => x.list_frequency ? x.list_frequency.toLowerCase() : null);
      getCurrencyId = groupData.map((x) => x.currency.id);

      getTempComments = groupData.map((x) => x.comments);

      getRebatesStatus = groupData.map((x) => {
        if (x.rebates_status) {
          var rebate_status_date = this.$moment(new Date(x.rebates_status));
          return rebate_status_date.format("MMMM YYYY");
        } else {
          return null;
        }
      });

      var geoData = groupData.map((x) => x.geo),
        customTagData = groupData.map((x) => x.customtag),
        promoTagData = groupData.map((x) => x.promotag),
        retailID = groupData.map((x) => x.retail),
        totalArray = groupData.length;
      for (var index = 0; index < totalArray; index++) {
        if (geoData[index] == null) {
          var geoNull = {
            label: "NA",
            value: null,
          };
          getTempGeo.push(geoNull);
        } else {
          var formatGeo = {
            label: geoData[index].name,
            value: geoData[index].id,
          };
          getTempGeo.push(formatGeo);
        }
        if (promoTagData[index] == null) {
          var tagNull = {
            label: "NA",
            value: null,
          };
          getTempPromoTag.push(tagNull);
        } else {
          var formatPromoTag = {
            label: promoTagData[index].tag_name,
            value: promoTagData[index].id,
          };
          getTempPromoTag.push(formatPromoTag);
        }
        if (customTagData[index] == null) {
          var tagNull = {
            label: "NA",
            value: null,
          };
          getTempCustomTag.push(tagNull);
        } else {
          var formatCustomTag = {
            label: customTagData[index].tag_name,
            value: customTagData[index].id,
          };
          getTempCustomTag.push(formatCustomTag);
        }
        if (retailID[index] == null) {
          var retailIdNull = {
            label: "USD  -  $",
            value: 12,
            sign: "$",
          };
          getRetailCurrency.push(retailIdNull);
        } else {
          var formatRetailCurrency = {
            label: retailID[index].name + "-" + retailID[index].sign,
            value: retailID[index].id,
            sign: retailID[index].sign,
          };
          getRetailCurrency.push(formatRetailCurrency);
        }
      }

      // console.log("groupData", groupData);

      // return;
      setTimeout(() => {
        // Pushing data into Local promo
        for (var index = 0; index < totalArray; index++) {
          this.promos.push({
            id: getTempId[index],
            promo_id: getTempPromoId[index],
            reseller_id: getTempResellerId[index],
            type: getTempType[index],
            tld_id: getTempTLD[index],
            period: getTempPeriod[index],
            selectableOption: getTempPeriod[index].includes("1") ? "All" : "",
            currencySign: groupData[0].currency.sign,
            year_price: getTempYearPrice[index],
            multi_year_price: getTempMultiYearPrice[index],
            year_price_per: getTempYearPerPrice[index],
            multi_year_price_per: getTempMultiYearPerPrice[index],
            retail_price: getTempRetailPrice[index],
            retail_currency: getRetailCurrency[index],
            promo_tag: getTempPromoTag[index],
            custom_tag: getTempCustomTag[index],
            geo: getTempGeo[index],
            start_date: getTempStartDate[index],
            end_date: getTempEndDate[index],
            rebates_status: getRebatesStatus[index],
            comments: getTempComments[index],
            new_local_agreement: null,
            status: getTempStatus[index],
            payment_mode: getPaymentMode[index],
            list_frequency: getListFreq[index],
            currency_id: getCurrencyId[index],
            list_based: getListBased[index].toLowerCase(),
            disabledYearPrice: (getTempPeriod[index].length == 1 && !getTempPeriod[index].includes("1")) && getTempType[index] !== 'renew' ? true : false,
            disabledMultiYearPrice: getTempPeriod[index].includes("1") || getTempType[index] == 'renew'  ? true : false,
            uploadedLocalFile: "",
            configFromdateTimePicker: {
              maxDate: null,
              wrap: true,
            },
            configTodateTimePicker: {
              minDate: null,
              wrap: true,
            },
          });

          this.$set(
            this.promos[index].configTodateTimePicker,
            "minDate",
            getTempStartDate[index]
          );
        }

      }, 50);
    },

    formatSingleDuplicateData(nodeData) {
      this.promos.splice(0);

      var groupData = nodeData;

      var getTempType,
        getTempTLD,
        getTempPeriod,
        getTempStartDate,
        getTempEndDate,
        getTempYearPrice,
        getTempMultiYearPrice,
        getTempYearPerPrice,
        getTempMultiYearPerPrice,
        getTempRetailPrice,
        getTempPromoTag = [],
        getTempCustomTag = [],
        getTempGeo = [],
        getTempComments,
        getTempId,
        getTempResellerId,
        getTempStatus,
        getPaymentMode,
        getListFreq,
        getListBased,
        getAgreements,
        getCurrencyId;

      getPaymentMode = groupData.map((x) => x.payment_mode ? x.payment_mode.toLowerCase() : null);
      getListFreq = groupData.map((x) => x.list_frequency ? x.list_frequency.toLowerCase() : null);
      getListBased = groupData.map((x) => x.list_based);
      getCurrencyId = groupData.map((x) => x.currency.id);

      getTempTLD = groupData.map((x) => {
        return {
          label: x.tld.tld_name,
          name: x.tld.tld_name,
          value: x.tld_id,
        };
      });
      getTempType = groupData.map((x) => x.type);
      getTempStatus = groupData.map((x) => x.status);
      getTempId = groupData.map((x) => x.id);
      getTempPeriod = groupData.map((x) => x.period);
      getTempStartDate = groupData.map((x) => x.start_date);
      getTempEndDate = groupData.map((x) => x.end_date);
      getTempResellerId = groupData.map((x) => {
        return {
          label: x.new_reseller.name,
          name: x.new_reseller.name,
          value: x.new_reseller_id,
        };
      });

      var datedate = [];

      if (groupData[0].approved_by) {
        this.flags["isApproved"] = true;
        this.formData["status"] = "active";
        if (this.flags["isDuplicate"]) {
          this.flags["isApproved"] = false;
          this.formData["status"] = "new pending";
          // for (var index = 0; index < groupData.length; index++) {
          datedate.push(null);
          getTempStartDate = datedate;
          getTempEndDate = datedate;
          // }
        }
      } else {
        this.flags["isApproved"] = false;
        this.formData["status"] = "new pending";
      }

      getTempYearPrice = groupData.map((x) => x.effective_first);
      getTempMultiYearPrice = groupData.map((x) => x.effective_multi);
      getTempYearPerPrice = groupData.map((x) => x.effective_first_per);
      getTempMultiYearPerPrice = groupData.map((x) => x.effective_multi_per);
      getTempRetailPrice = groupData.map((x) => x.retail_price);
      // getTempPromoTag = groupData.map((x) => {
      //   return {
      //     label: x.promotag.tag_name,
      //     value: x.promo_tag_id,
      //   };
      // });
      getTempComments = groupData.map((x) => x.comments);

      // var getTempAgreementData = groupData.map((x) => {
      //   return x.promo_agreement.map((y) => {
      //     return {
      //       fileName: y.filename,
      //       fileLink: y.dropbox_link,
      //     };
      //   });
      // });

      var geoData = groupData.map((x) => x.geo),
        customTagData = groupData.map((x) => x.customtag),
        promoTagData = groupData.map((x) => x.promotag);

      var totalArray = groupData.length;
      for (var index = 0; index < totalArray; index++) {
        if (geoData[index] == null) {
          var geoNull = {
            label: "NA",
            value: null,
          };
          getTempGeo.push(geoNull);
        } else {
          var formatGeo = {
            label: geoData[index].name,
            value: geoData[index].id,
          };
          getTempGeo.push(formatGeo);
        }
        if (promoTagData[index] == null) {
          var tagNull = {
            label: "NA",
            value: null,
          };
          getTempPromoTag.push(tagNull);
        } else {
          var formatPromoTag = {
            label: promoTagData[index].tag_name,
            value: promoTagData[index].id,
          };
          getTempPromoTag.push(formatPromoTag);
        }
        if (customTagData[index] == null) {
          var tagNull = {
            label: "NA",
            value: null,
          };
          getTempCustomTag.push(tagNull);
        } else {
          var formatCustomTag = {
            label: customTagData[index].tag_name,
            value: customTagData[index].id,
          };
          getTempCustomTag.push(formatCustomTag);
        }
      }
      // console.log("groupData", groupData);
      var retailID = groupData.map((x) => x.retail_currency_id);
      if (retailID[0] != null) {
        var getRetailCurrency = groupData.map((x) => {
          return {
            label: x.retail.name + "-" + x.retail.sign,
            value: x.retail.id,
            sign: x.retail.sign,
          };
        });
      } else {
        var getRetailCurrency = {
          label: "USD  -  $",
          value: 12,
          sign: "$",
        };
      }

      getAgreements = groupData[0].agreement_new.map((x) => x.id);

      // return;
      setTimeout(() => {
        // Pushing data into Local promo
        for (var index = 0; index < totalArray; index++) {
          this.promos.push({
            id: getTempId[index],
            reseller_id: getTempResellerId[index],
            type: getTempType[index],
            tld_id: getTempTLD[index],
            period: getTempPeriod[index],
            currencySign: groupData[0].currency.sign,
            year_price: getTempYearPrice[index],
            multi_year_price: getTempMultiYearPrice[index],
            year_price_per: getTempYearPerPrice[index],
            multi_year_price_per: getTempMultiYearPerPrice[index],
            retail_price: getTempRetailPrice[index],
            retail_currency: retailID[0]
              ? getRetailCurrency[index]
              : getRetailCurrency,
            promo_tag: getTempPromoTag[index],
            custom_tag: getTempCustomTag[index],
            geo: getTempGeo[index],
            start_date: null,
            end_date: null,
            comments: getTempComments[index],
            new_local_agreement: null,
            local_agreements: getAgreements,
            status: getTempStatus[index],
            // fileLocalData: getTempAgreementData[index],
            uploadedLocalFile: "",
            payment_mode: getPaymentMode[index],
            list_frequency: getListFreq[index],
            list_based: getListBased[index],
            currency_id: getCurrencyId[index],
            configFromdateTimePicker: {
              minDate: new Date(this.$moment().subtract(9, 'months')),
              maxDate: null,
              wrap: true,
            },
            configTodateTimePicker: {
              minDate: null,
              wrap: true,
            },
          });
        }

        this.handlePeriod(true);
      }, 50);
    },

    onSubmit() {
      var priceObject = {
        amtNum: [],
        perNum: [],
        amtMulti: [],
        perMulti: [],
        retailPrice: [],
      };

      this.promos.forEach((x) => {
        if (!x.type.includes("premium")) {
          priceObject["amtNum"].push(
            (Math.round(x.year_price * 100) / 100).toFixed(2)
          );
          priceObject["amtMulti"].push(
            (Math.round(x.multi_year_price * 100) / 100).toFixed(2)
          );
          priceObject["retailPrice"].push(
            (Math.round(x.retail_price * 100) / 100).toFixed(2)
          );
          priceObject["perNum"].push(0);
          priceObject["perMulti"].push(0);
        } else {
          priceObject["amtNum"].push(0);
          priceObject["amtMulti"].push(0);
          priceObject["retailPrice"].push(0);
          priceObject["perNum"].push(
            (Math.round(x.year_price_per * 100) / 100).toFixed(2)
          );
          priceObject["perMulti"].push(
            (Math.round(x.multi_year_price_per * 100) / 100).toFixed(2)
          );
        }
      });

      if (this.formData["general_agreements"] == null) {
        var getNewGeneralAgreement = null;
      } else {
        var getNewGeneralAgreement = this.formData["general_agreements"];
      }
      var getExistingGeneralAgreement = this.formData["agreement"]["value"];

      var localPromoData = {};

      localPromoData = this.promos.map((x, index) => {
        return {
          id: x.id,
          payment_mode: x["payment_mode"].toLowerCase(),
          list_frequency: x["list_frequency"].toLowerCase(),
          list_based: x["list_based"],
          currency_id: x["currency_type"] ? x["currency_type"]["value"] : x.currency_id,
          // reseller_id: x.reseller_id.value,
          new_reseller_id: x.reseller_id.value,
          // status: x.status,
          status: "approval pending",
          tld_id: x.tld_id.value,
          type: x.type,
          period: x.period,
          start_date: x.start_date,
          end_date: x.end_date,
          effective_first: priceObject["amtNum"][index],
          effective_multi: priceObject["amtMulti"][index],
          effective_first_per: priceObject["perNum"][index],
          effective_multi_per: priceObject["perMulti"][index],
          promo_tag_id: x.promo_tag.value,
          custom_tag_id: x.custom_tag.value,
          geo_id: x.geo.value,
          comments: x.comments,
          new_local_agreement: x["new_local_agreement"],
          existing_local_agreement: null,
          retail_price: priceObject["retailPrice"][index],
          retail_currency_id: x.retail_currency.value,
        };
      });

      // console.log("localPromoData :>> ", localPromoData);

      this.$validator.validateAll().then((result) => {
        // console.log("form");
        if (result) {
          this.editPromoRequestPopup = false;
          //Loader
          this.openLoadingInDiv();

          this.$axiosSecure
            .post("/local-promos-requests/edit", localPromoData)
            .then((response) => {
              // console.log(response.data);
              // Hide loader
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();
              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "Internal Promo edited",
                  text: "Selected Internal Promo has been successfully edited.",
                  acceptText: "Close",
                  // accept: () => {
                  //   this.$router.push({ path: "/internal-promo-list" });
                  // }
                });
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();
              console.log(error.response.message);
              if (error.response.data.resoneOfError == "local promo duplicate") {
                setTimeout(() => {
                  //Error msg
                  this.$vs.dialog({
                    color: "danger",
                    title: "Error",
                    text: "Internal Promo already exists and hence could not be edited.",
                    acceptText: "Close",
                    accept: () => {
                      // console.log('cancel');
                    },
                  });
                }, 100);
              }
            });
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    onEditSubmit() {
      var localPromoData = {};

      var priceObject = {
        amtNum: [],
        perNum: [],
        amtMulti: [],
        perMulti: [],
        retailPrice: [],
      };

      this.promos.forEach((x) => {
        if (!x.type.includes("premium")) {
          priceObject["amtNum"].push(
            (Math.round(x.year_price * 100) / 100).toFixed(2)
          );
          priceObject["amtMulti"].push(
            (Math.round(x.multi_year_price * 100) / 100).toFixed(2)
          );
          priceObject["retailPrice"].push(
            (Math.round(x.retail_price * 100) / 100).toFixed(2)
          );
          priceObject["perNum"].push(0);
          priceObject["perMulti"].push(0);
        } else {
          priceObject["amtNum"].push(0);
          priceObject["amtMulti"].push(0);
          priceObject["retailPrice"].push(0);
          priceObject["perNum"].push(
            (Math.round(x.year_price_per * 100) / 100).toFixed(2)
          );
          priceObject["perMulti"].push(
            (Math.round(x.multi_year_price_per * 100) / 100).toFixed(2)
          );
        }
      });

      localPromoData = this.promos.map((x, index) => {
        return {
          id: this.editReq ? x.id : undefined,
          local_promo_id: this.editReq ? x.promo_id : x.id,
          start_date: x.start_date,
          end_date: x.end_date,
          retail_price: x.retail_price,
          retail_currency_id: x.retail_currency.value,
          effective_first: priceObject["amtNum"][index],
          effective_multi: priceObject["amtMulti"][index],
          effective_first_per: priceObject["perNum"][index],
          effective_multi_per: priceObject["perMulti"][index],
          promo_tag_id: x.promo_tag.value,
          custom_tag_id: x.custom_tag.value,
          geo_id: x.geo.value,
          status: "edit pending",
          comments: x.comments,
          extended: this.extended,
        };
      });

      // console.log("localPromoData", localPromoData);
      // return;

      this.$validator.validateAll().then((result) => {
        // console.log("form onEditSubmit");
        if (result) {
          this.editPromoRequestPopup = false;
          //Loader
          this.openLoadingInDiv();
          // this.flags["isFormSubmitted"] = true;

          if (this.flags["enableOnlyRebateStatus"]) {
            let payload = [],
              months = [
                "january",
                "february",
                "march",
                "april",
                "may",
                "june",
                "july",
                "august",
                "september",
                "october",
                "november",
                "december",
              ];

            this.promos.map((x) => {
              payload.push({
                local_promo_id: x.id,
                month:
                  x.rebates_status !== null
                    ? months[new Date(x.rebates_status).getMonth()] +
                      "-" +
                      new Date(x.rebates_status).getFullYear()
                    : null,
                custom_tag_id: x.custom_tag.value,
              });
            });

            // console.log("payload :>> ", payload);

            this.$axiosSecure
              .post("/local-promos/edit/rebates-status", payload)
              .then((response) => {
                this.hideLoadingInDiv();
                this.resetFields();
                this.tableRefresh();
                // console.log(response.data);
                setTimeout(() => {
                  // Confimation notification
                  this.$vs.dialog({
                    color: "success",
                    title: "Internal Promo rebate status updated",
                    text: "Selected Internal Promo rebate status has been successfully updated.",
                    acceptText: "Close",
                  });
                }, 100);
              })
              .catch((error) => {
                console.log(error);
                // Hide loader
                this.hideLoadingInDiv();
                setTimeout(() => {
                  //Error msg
                  this.$vs.dialog({
                    color: "danger",
                    title: "Error",
                    text: "Internal Promo rebate status could not be updated.",
                    acceptText: "Close",
                    accept: () => {
                      // console.log('cancel');
                    },
                  });
                }, 100);
              });
          } else {
            let url = this.editReq
              ? "/local-promos/edit/requests"
              : "/local-promos/edit";

            this.$axiosSecure
              .post(url, localPromoData)
              .then((response) => {
                this.hideLoadingInDiv();
                this.resetFields();
                this.tableRefresh();
                // console.log(response.data);
                setTimeout(() => {
                  // Confimation notification
                  this.$vs.dialog({
                    color: "success",
                    title: "Internal Promo edited",
                    text: "Selected Internal Promo has been successfully edited.",
                    acceptText: "Close",
                  });
                }, 100);
              })
              .catch((error) => {
                console.log(error);
                // Hide loader
                this.hideLoadingInDiv();
                //   console.log(error.response.message);
                if (error.response.data.resoneOfError == "local promo duplicate") {
                  setTimeout(() => {
                    //Error msg
                    this.$vs.dialog({
                      color: "danger",
                      title: "Error",
                      text: "Internal Promo already exists and hence could not be edited.",
                      acceptText: "Close",
                      accept: () => {
                        // console.log('cancel');
                      },
                    });
                  }, 100);
                }
              });
          }
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    onDuplicateSubmit() {
      var priceObject = {
        amtNum: [],
        perNum: [],
        amtMulti: [],
        perMulti: [],
        retailPrice: [],
      };

      this.promos.forEach((x) => {
        if (!x.type.includes("premium")) {
          priceObject["amtNum"].push(
            (Math.round(x.year_price * 100) / 100).toFixed(2)
          );
          priceObject["amtMulti"].push(
            (Math.round(x.multi_year_price * 100) / 100).toFixed(2)
          );
          priceObject["retailPrice"].push(
            (Math.round(x.retail_price * 100) / 100).toFixed(2)
          );
          priceObject["perNum"].push(0);
          priceObject["perMulti"].push(0);
        } else {
          priceObject["amtNum"].push(0);
          priceObject["amtMulti"].push(0);
          priceObject["retailPrice"].push(0);
          priceObject["perNum"].push(
            (Math.round(x.year_price_per * 100) / 100).toFixed(2)
          );
          priceObject["perMulti"].push(
            (Math.round(x.multi_year_price_per * 100) / 100).toFixed(2)
          );
        }
      });

      if (this.formData["general_agreements"] == null) {
        var getNewGeneralAgreement = null;
      } else {
        var getNewGeneralAgreement = this.formData["general_agreements"];
      }
      var getExistingGeneralAgreement = this.formData["agreement"]["value"];

      var localPromoData = {};

      // localPromoData = this.promos.map((x, index) => {
      //   return {
      // id: x.id,
      // payment_mode: this.formData["payment_mode"].toLowerCase(),
      // list_frequency: this.formData["list_frequency"].toLowerCase(),
      // list_based: this.formData["list_based"],
      // currency_id: this.formData["currency_type"]["value"],
      // user_id: JSON.parse(localStorage.getItem("userDetails")).id,
      // reseller_id: this.promos[0].reseller_id.value,
      // status: "approval pending",
      // localpromo: [{
      //   tld_id: this.promos[0].tld_id.value,
      // type: this.promos[0].type,
      // period: this.promos[0].period,
      // start_date: this.promos[0].start_date,
      // end_date: this.promos[0].end_date,
      // effective_first: priceObject["amtNum"][index],
      // effective_multi: priceObject["amtMulti"][index],
      // effective_first_per: priceObject["perNum"][index],
      // effective_multi_per: priceObject["perMulti"][index],
      // promo_tag_id: this.promos[0].promo_tag.value,
      // custom_tag_id: this.promos[0].custom_tag.value,
      // geo_id: this.promos[0].geo.value,
      // comments: this.promos[0].comments,
      // new_local_agreement: x["new_local_agreement"],
      // existing_local_agreement: null,
      // retail_price: priceObject["retailPrice"][index],
      // retail_currency_id: this.promos[0].retail_currency.value
      // }]
      //   };
      // });

      // console.log("localPromoData :>> ", localPromoData);

      this.$validator.validateAll().then((result) => {
        // console.log("form");
        if (result) {
          this.editPromoRequestPopup = false;
          //Loader
          this.openLoadingInDiv();

          // console.log("Duplicate payload", {
          //     payment_mode:
          //         this.promos[0]["payment_mode"].toLowerCase(),
          //     list_frequency:
          //         this.promos[0]["list_frequency"].toLowerCase(),
          //     currency_id: this.promos[0]["currency_id"],
          //     user_id: JSON.parse(localStorage.getItem("userDetails"))
          //         .id,
          //     reseller_id: this.promos[0].reseller_id.value,
          //     // new_reseller_id: this.promos[0].reseller_id.value,
          //     status: "approval pending",
          //     general_agreements: [],
          //     localpromo: [
          //         {
          //             tld_id: [this.promos[0].tld_id.value],
          //             type: this.promos[0].type,
          //             period: this.promos[0].period,
          //             start_date: this.promos[0].start_date,
          //             end_date: this.promos[0].end_date,
          //             effective_first: priceObject["amtNum"][0],
          //             effective_multi: priceObject["amtMulti"][0],
          //             effective_first_per: priceObject["perNum"][0],
          //             effective_multi_per: priceObject["perMulti"][0],
          //             promo_tag_id: this.promos[0].promo_tag.value,
          //             custom_tag_id: this.promos[0].custom_tag.value,
          //             geo_id: this.promos[0].geo.value,
          //             comments: this.promos[0].comments,
          //             local_agreements: [],
          //             retail_price: priceObject["retailPrice"][0],
          //             retail_currency_id:
          //                 this.promos[0].retail_currency.value,
          //             list_based: this.promos[0]["list_based"],
          //         },
          //     ],
          // });

          this.$axiosSecure
            .post("/local-promos-request/duplicate", {
              payment_mode: this.promos[0]["payment_mode"] ? this.promos[0]["payment_mode"].toLowerCase() : this.promos[0]["payment_mode"],
              list_frequency: this.promos[0]["list_frequency"] ? this.promos[0]["list_frequency"].toLowerCase() : this.promos[0]["list_frequency"],
              currency_id: this.promos[0]["currency_id"],
              user_id: JSON.parse(localStorage.getItem("userDetails")).id,
              // reseller_id: this.promos[0].reseller_id.value,
              new_reseller_id: this.promos[0].reseller_id.value,
              status: "approval pending",
              general_agreements: [],
              localpromo: [
                {
                  tld_id: [this.promos[0].tld_id.value],
                  type: this.promos[0].type,
                  period: this.promos[0].period,
                  start_date: this.promos[0].start_date,
                  end_date: this.promos[0].end_date,
                  effective_first: priceObject["amtNum"][0],
                  effective_multi: priceObject["amtMulti"][0],
                  effective_first_per: priceObject["perNum"][0],
                  effective_multi_per: priceObject["perMulti"][0],
                  promo_tag_id: this.promos[0].promo_tag.value,
                  custom_tag_id: this.promos[0].custom_tag.value,
                  geo_id: this.promos[0].geo.value,
                  comments: this.promos[0].comments,
                  local_agreements: [],
                  retail_price: priceObject["retailPrice"][0],
                  retail_currency_id: this.promos[0].retail_currency.value,
                  list_based: this.promos[0]["list_based"],
                },
              ],
            })
            .then((response) => {
              // console.log(response.data);
              // Hide loader
              this.hideLoadingInDiv();
              this.resetFields();
              this.tableRefresh();
              setTimeout(() => {
                // Confimation notification
                this.$vs.dialog({
                  color: "success",
                  title: "Internal Promo duplicated",
                  text: "Selected Internal Promo has been successfully duplicated.",
                  acceptText: "Close",
                  // accept: () => {
                  //   this.$router.push({ path: "/internal-promo-list" });
                  // }
                });
              }, 100);
            })
            .catch((error) => {
              console.log(error);
              // Hide loader
              this.hideLoadingInDiv();
              console.log(error.response.message);
              if (error.response.data.resoneOfError == "local promo duplicate") {
                setTimeout(() => {
                  //Error msg
                  this.$vs.dialog({
                    color: "danger",
                    title: "Error",
                    text: "Internal Promo already exists and hence could not be edited.",
                    acceptText: "Close",
                    accept: () => {
                      // console.log('cancel');
                    },
                  });
                }, 100);
              }
            });
        } else {
          // form have errors
          // console.log("form have errors");
        }
      });
    },

    openAddTagModal(counter) {
      // console.log("In add custom tag modal");

      this.popupCustomTag = true;
      this.tempCustomTag = counter;
    },

    onAddCustomTag() {
      // console.log("In add custom tag");
      //Loader
      this.$vs.loading({
        container: ".div-with-agreement-modal-loading",
        scale: 0.8,
      });

      this.$axiosSecure
        .post("/custom-tag", {
          tag_name: this.formData["CustomeTagName"].toLowerCase(),
          comments: this.formData["CustomeTagComments"],
        })
        .then((response) => {
          // console.log('done', response.data);
          var tempObj = {
            label: response.data.map((x) => x.tag_name).toString(),
            value: response.data.map((x) => x.id).toString(),
          };
          this.popupCustomTag = false;

          setTimeout(() => {
            this.promos[this.tempCustomTag].custom_tag = tempObj;
            this.formData["CustomeTagName"] = "";
            this.formData["CustomeTagComments"] = "";
            this.tempCustomTag = "";
            // Hide loader
            this.$vs.loading.close(
              ".div-with-agreement-modal-loading > .con-vs-loading"
            );
            // Confimation notification
            this.$vs.dialog({
              color: "success",
              title: "Custom Tag added",
              text: "Custom tag has been successfully added.",
              acceptText: "Close",
            });
          }, 100);

          this.$store.dispatch("setCustomTags");
        })
        .catch((error) => {
          // console.log(error);
          this.popupCustomTag = false;
          // Hide loader
          this.$vs.loading.close(
            ".div-with-agreement-modal-loading > .con-vs-loading"
          );
          setTimeout(() => {
            //Error msg
            this.$vs.dialog({
              color: "danger",
              title: "Error",
              text: "Please contact the server admin.",
              acceptText: "Close",
            });
          }, 100);
        });
    },

    resetFields() {
      (this.batchId = ""), (this.formData["reseller_id"] = []);
      this.formData["payment_mode"] = [];
      this.formData["list_frequency"] = [];
      this.formData["list_based"] = "Yes";
      this.formData["agreement"] = { label: "New", value: null };
      (this.formData["general_agreements"] = null),
        (this.formData["status"] = ""),
        (this.uploadedFile = ""),
        this.promos.forEach((element) => {
          (element.type = []),
            (element.tld_id = []),
            (element.period = []),
            (element.start_date = null),
            (element.end_date = null),
            (element.retail_price = ""),
            (element.year_price = ""),
            (element.multi_year_price = ""),
            (element.year_price_per = ""),
            (element.multi_year_price_per = ""),
            (element.promo_tag = []),
            (element.custom_tag = []),
            (element.geo = []),
            (element.comments = ""),
            (element.id = ""),
            (element.fileLocalData = []),
            (element.uploadedLocalFile = ""),
            (element.selectableOption = ""),
            (element.status = ""),
            (element.new_local_agreement = null);
        });
      //Remove all the repetative form data and keep only one
      this.promos.splice(1);
    },

    tableRefresh() {
      this.$root.$emit("tableRefresh");
    },

    onFromChange(event, counter) {
      this.$set(
        this.promos[counter].configTodateTimePicker,
        "minDate",
        event[0]
      );
      // console.log('counter', counter);
      // console.log('event', event);
    },

    onToChange(event, counter) {
      this.$set(
        this.promos[counter].configFromdateTimePicker,
        "maxDate",
        event[0]
      );
    },

    handlePeriod(event) {
      // console.log("event :>> ", event);
      this.promos.forEach((element) => {
        if (element["period"]) {
          if (!element["period"].length) {
            element["selectableOption"] = "";
            element["disabledYearPrice"] = false;
            element["disabledMultiYearPrice"] = false;
          } else {
            if (element["period"].includes("1")) {
              element["selectableOption"] = "All";
              element["disabledYearPrice"] = false;
              element["disabledMultiYearPrice"] = true;
              element["multi_year_price"] = "";
              element["multi_year_price_per"] = "";
            } else {
              element["selectableOption"] = "Other than All";
              if (
                element["period"].length == 1 &&
                !element.type.includes("renew")
              ) {
                element["disabledYearPrice"] = true;
                element["year_price"] = "";
                element["year_price_per"] = "";
              } else {
                element["disabledYearPrice"] = false;
              }
            }
          }
        }
      });
    },

    copyEndDate() {
      navigator.clipboard.readText().then(
          (textCopied) => {
            this.promos.map(x => {
              x.end_date = textCopied.toString();
            })
          },
          (err) => {
              console.error('Could not paste text: ', err)
          }
      );
    }
  },
};
</script>

<style></style>
